"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.type.message': 'Napisz wiadomość...',
};
